<template>
  <div>
    <Return_product_detall/>
  </div>
</template>

<script>
import Return_product_detall from "@/components/adminArin/pos_system/warehouse/return_product/Return_product_detail";
export default {
  name: "Returnproductdetall",
  components: {
    Return_product_detall
  }
}
</script>

<style scoped>

</style>
